import type { SchemaDesignerCategoryInstance } from "./schemaDesigner/types";
import { isRelationInstance } from "./sheetPlanner";

export function isConnectedToMain(
  categories: readonly SchemaDesignerCategoryInstance[],
  targetInstanceId: string | undefined,
  visited = new Set<string>(),
): boolean {
  if (!targetInstanceId) return false;
  const category = categories.find((c) => c.instanceId === targetInstanceId);
  if (!category) return false;
  if (category.isMain) return true;

  if (visited.has(targetInstanceId)) return false;
  visited.add(targetInstanceId);

  if (isRelationInstance(category)) {
    const sourceConnected = category.sourceCategory?.instanceId
      ? isConnectedToMain(categories, category.sourceCategory?.instanceId, visited)
      : false;
    const targetConnected = category.targetCategory?.instanceId
      ? isConnectedToMain(categories, category.targetCategory?.instanceId, visited)
      : false;
    return sourceConnected || targetConnected;
  }

  const connectingRelations = categories
    .filter(isRelationInstance)
    .filter(
      (c) => c.sourceCategory?.instanceId === targetInstanceId || c.targetCategory?.instanceId === targetInstanceId,
    );

  for (const relation of connectingRelations) {
    const otherId =
      relation.sourceCategory?.instanceId === targetInstanceId
        ? relation.targetCategory?.instanceId
        : relation.sourceCategory?.instanceId;
    if (otherId && isConnectedToMain(categories, otherId, visited)) {
      return true;
    }
  }

  return false;
}
